import React, { Component } from 'react';
import Icon from '../Icon';
import { ICON_TYPE_CLOSE } from '../Icon/constants';
import './Tags.css';
import withTheme from '../../hocs/withTheme';
import { getClassNames } from '../../utils';

type TagsProps = {
    data?: string[];
    title?: string | null;
    onChange?: (values: string[]) => void;
    isMobile?: boolean;
    labelRemove?: string;
    labelReset?: string;
    className?: string;
};

type TagsState = {
    selected: string[];
};

class Tags extends Component<TagsProps, TagsState> {
    static defaultProps: Partial<TagsProps> = {
        title: null,
        onChange: () => {},
        isMobile: false,
        labelRemove: 'Remove',
        labelReset: 'Reset filters',
    };

    constructor(props: TagsProps) {
        super(props);
        this.state = {
            selected: [],
        };
    }

    static getDerivedStateFromProps(nextProps: TagsProps) {
        return { selected: nextProps.data || [] };
    }

    clearSelected = (item: string) => {
        this.setState(({ selected }) => (
            { selected: selected.filter((selectable) => selectable !== item) }
        ));
        this.props.onChange?.(this.state.selected.filter((selectable) => selectable !== item));
    };

    clearSelectedTags = () => {
        this.setState({ selected: [] });
        this.props.onChange?.([]);
    };

    className = () => getClassNames('Tags', { 'Tags-mobile': this.props.isMobile });

    render() {
        const {
            props: {
                title,
                isMobile,
                labelRemove,
                labelReset,
            },
            state: { selected },
        } = this;

        return (
            <div className={this.className()}>
                <div className="tags-list">
                    {!isMobile && title && <b>{title}</b>}
                    {selected.map((item) => (
                        <span className="tag-item" key={item}>
                            <span>{item}</span>
                            <Icon
                                role="button"
                                tabIndex={0}
                                ariaLabel={`${labelRemove} ${item}`}
                                type={ICON_TYPE_CLOSE}
                                onClick={() => this.clearSelected(item)}
                            />
                        </span>
                    ))}
                </div>
                <button type="button" onClick={this.clearSelectedTags}>{labelReset}</button>
            </div>
        );
    }
}

export default withTheme(Tags);
